
/**
 *
 */

+function($){

  page.initDrawer = function() {

    $(document).on( 'click', '.drawer-toggler, .drawer-close, .backdrop-drawer', function() {
      $('body').toggleClass( 'drawer-open' );
    });

  }

}(jQuery);




//////////////////
// WEBPACK FOOTER
// ./src/assets/plugin/thesaas/js/partials/drawer.js
// module id = 66
// module chunks = 0